import { Image, Linking, Pressable } from "react-native"

import { useQuery } from "@tanstack/react-query"

import { H3, H6, Small } from "@/components/standard/BFText"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import sdk from "@/api/sdk"
import { router } from "expo-router"

interface LoanDashboardHeaderProps {
  loanId: string
}

function UpperHeader({ imageUri }: UpperHeaderProps) {
  return (
    <>
      <Horizontal className="pt-2.5 pb-2 justify-between items-center">
        <Horizontal className="h-[50px] justify-start items-center">
          <Image
            className="overflow-hidden rounded-full"
            source={{ uri: imageUri || "" }}
            resizeMode="cover"
            height={50}
            style={{ height: 50, width: 50 }}
          />
        </Horizontal>
      </Horizontal>
    </>
  )
}

export function LoanDashboardHeader({ loanId }: LoanDashboardHeaderProps) {
  const headerQuery = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return {
        streetAddress: `${data?.property?.street!}`.trim(),
        cityStateZip:
          `${data?.property?.city}, ${data?.property?.state} ${data?.property?.zipcode}`.trim(),
        timelineStage: data?.timelineStage!,
        imageUri: data?.property?.heroImage || undefined,
        termSheetUrl: data?.processing?.termSheetUrl || undefined,
        externalLoanId: data?.externalLoanId || undefined,
        status: data?.status,
      }
    },
  })

  if (!headerQuery.data) {
    return null
  }

  const {
    streetAddress,
    cityStateZip,
    imageUri,
    externalLoanId,
    termSheetUrl,
    status,
  } = headerQuery.data

  function termSheetPress() {
    void (async () => {
      const fileData = await sdk.getHubspotFileUrl({
        fileId: termSheetUrl!,
      })
      if (fileData?.getHubspotFileUrl?.fileUrl?.url) {
        void Linking.openURL(fileData?.getHubspotFileUrl?.fileUrl?.url)
      } else {
        alert("Cannot open file")
      }
    })()
  }

  function quotePress() {
    router.push(`/loans/${loanId}/dashboard/details`)
  }

  return (
    <Vertical className={"min-h-32"}>
      <UpperHeader imageUri={imageUri} />
      <Horizontal className="flex-1 pb-2 border-b border-light-grey ">
        <Horizontal className="justify-between flex-1 items-end">
          <Vertical>
            <H3>{streetAddress}</H3>
            <Small className="text-dark-grey">{cityStateZip}</Small>
          </Vertical>
          <Vertical className="items-end justify-end">
            {termSheetUrl ? (
              <Pressable onPress={termSheetPress} testID={"term-sheet"}>
                <H6 color="primaryLight">View Terms</H6>
              </Pressable>
            ) : status !== "started" ? (
              <Pressable onPress={quotePress} testID={"view-quote"}>
                <H6 color="primaryLight">View Quote</H6>
              </Pressable>
            ) : null}
            {externalLoanId && (
              <Small className="text-dark-grey">
                Loan ID: {externalLoanId}
              </Small>
            )}
          </Vertical>
        </Horizontal>
      </Horizontal>
    </Vertical>
  )
}

interface UpperHeaderProps {
  imageUri: string | undefined
}
